export default {"src":"/_next/static/media/airmeet-logo.4a49d533.svg","height":28,"width":114};